import {createAction, props} from '@ngrx/store';

export const login = createAction('[Auth] Login', props<any>());
export const loginSuccess = createAction('[Auth] Login Success');
export const loginFailure = createAction('[Auth] Login Failure');   

export const signup = createAction('[Auth] Sign Up', props<any>());
export const signupSuccess = createAction('[Auth] Sign Up Success');
export const signupFailure = createAction('[Auth] Sign Up Failure');

export const verifyEmail = createAction('[Auth] Verify Email', props<any>());
export const verifyEmailSuccess = createAction('[Auth] Verify Email Success');
export const verifyEmailFailure = createAction('[Auth] Verify Email Failure');

export const forgotPassword = createAction('[Auth] Forgot Password', props<any>());
export const forgotPasswordSuccess = createAction('[Auth] Forgot Password Success');
export const forgotPasswordFailure = createAction('[Auth] Forgot Password Failure');

export const resetPassword = createAction('[Auth] Reset Password', props<any>());
export const resetPasswordSuccess = createAction('[Auth] Reset Password Success');
export const resetPasswordFailure = createAction('[Auth] Reset Password Failure');

export const resendOtp = createAction('[Auth] Resend OTP', props<any>());
export const resendOtpSuccess = createAction('[Auth] Resend OTP Success');
export const resendOtpFailure = createAction('[Auth] Resend OTP Failure');

export const validatePasswordResetOtp = createAction('[Auth] Validate Password Reset OTP', props<{ email: string; otp: string }>());
export const validatePasswordResetOtpSuccess = createAction('[Auth] Validate Password Reset OTP Success');
export const validatePasswordResetOtpFailure = createAction('[Auth] Validate Password Reset OTP Failure');

